import { connect } from 'react-redux';
import AddOther from './add_other';
import { closePanel } from '../../actions/panel';
// import { addToCanvas } from '../../actions/canvas';

const mapStateToProps = ({ works, customImage: { src: ciSrc }, wallPaper: { src: wpSrc } }) => ({
  ...works,
  hasCustomImage: !!ciSrc,
  hasWallPaper: !!wpSrc
});

export default connect(mapStateToProps, {
  closePanel
})(AddOther);
